var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9808 10.3004C17.9437 10.1151 17.8546 9.94413 17.7239 9.80759C17.5932 9.67105 17.4263 9.57456 17.2428 9.52941L10.3828 7.81341L12.9198 1.89241C13.0082 1.68694 13.025 1.45774 12.9675 1.24158C12.91 1.02542 12.7816 0.834837 12.6028 0.700413C12.4243 0.565106 12.2055 0.493881 11.9816 0.498235C11.7577 0.50259 11.5418 0.58227 11.3688 0.724413L0.368787 9.72441C0.225304 9.84179 0.11727 9.99673 0.0567491 10.1719C-0.003772 10.3472 -0.0143982 10.5358 0.0260568 10.7167C0.0665118 10.8976 0.156456 11.0637 0.285845 11.1964C0.415234 11.3292 0.578976 11.4233 0.758786 11.4684L7.47779 13.1494L4.13279 19.0034C4.04649 19.1555 4.00154 19.3275 4.00241 19.5024C4.00328 19.6772 4.04993 19.8488 4.13773 20C4.22552 20.1512 4.3514 20.2768 4.50282 20.3643C4.65424 20.4517 4.82593 20.498 5.00079 20.4984C5.21722 20.4988 5.42786 20.4286 5.60079 20.2984L17.6008 11.2984C17.752 11.185 17.8679 11.031 17.9352 10.8544C18.0024 10.6777 18.0182 10.4857 17.9808 10.3004Z",
    fill: "#6442EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.8eccd2c6637de81a606657109afbf05f.svg";
export { ForwardRef as ReactComponent };